import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import Form from "./Form";
import Actions from "../../../Actions";
import Tile from "../Layout/Tile";

class UserAdd extends Component{
    constructor(props){
        super(props);
        this.alertRef = false;
    }

    componentDidUpdate(){
        const {userStore: { alert: { add } } } = this.props;
        if(add && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
    }

    render = () => {
        const { userStore: { alert: { add } }, modalStore: {add: { modal }}, toggleModal, addUser } = this.props;
        return (
            <div>
                <Modal size="lg" isOpen={modal} keyboard={false} toggle={() => toggleModal("users","add")}>
                    <ModalHeader toggle={() => toggleModal("users","add")}>Add User</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {add !== false &&
                                    <Alert color={add.type}>
                                        { add.message }
                                    </Alert>                                         
                                }
                                <Form data='' persist={addUser} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    userStore: state.userStore,
    modalStore: state.modalStore.users,
});

const { users, modals } = Actions;

export default connect(mapStateToProps, { ...users, ...modals })(UserAdd);


// WEBPACK FOOTER //
// ./src/Components/App/Users/Add.js